<template>
    <div class="page-pay" v-loading="loading">
        <div class="table common-wrap" >
            <div class="tit"><!--共 5 笔-->订单</div>
            <div class="table-f">
                <el-table
                        :data="tableData"
                        stripe
                >
                    <el-table-column
                            prop="productName"
                            label="名称"
                            min-width="200"
                    >
                    </el-table-column>
                    <el-table-column
                            prop="tradePayNo"
                            label="交易号"
                            align="center"
                            min-width="150"
                    >
                        <template >
                            <span>{{orderNumber}}</span>
                        </template>
                    </el-table-column>
                    <!--<el-table-column
                            prop="userName"
                            label="作者"
                            align="center"
                            min-width="150"
                    >
                    </el-table-column>-->
                    <!--<el-table-column
                            label="金额"
                            align="center"
                            min-width="100"
                            fixed="right"
                    >
                        <template slot-scope="scope">
                            <span class="price-style" >￥{{scope.row.experience}}</span>
                        </template>
                    </el-table-column>-->
                </el-table>
            </div>
        </div>
        <div class="pay-wrap common-wrap">
            <div class="top-wrap com-pad" v-if="wechatpayType == 'notwxpay'">
                <div class="tit">请选择支付方式：</div>
                <ul class="pay-type clearfix">
                    <li @click="selectPayType(1)" :class="{'active': payTypeNum === 1}"><img
                            :src="require('@/assets/images/pay_wechat.jpg')" alt=""></li>
                    <li @click="selectPayType(0)" :class="{'active': payTypeNum === 0}"><img
                            :src="require('@/assets/images/pay_ali.jpg')" alt=""></li>

                </ul>
            </div>
            <div class="bot-wrap com-pad">
                <div>
                    <div class="price" :code="code" :wechatpayType="wechatpayType">
                        商品金额：￥{{finalPrice}}
                        <span class="oldd-p" v-if="useShared">
                            原价：
                            <span class="p-p">￥{{originalPrice}}</span>
                        </span>
<!--                        <span class="you-hui" v-if="useShared">享受分享码9折优惠</span>-->
                    </div>
                    <!--<div class="youhui-code share-code">
                        <i
                            class="btn-share-code"
                            :class="{'el-icon-circle-plus-outline': !showShareCode, 'el-icon-remove-outline': showShareCode}"
                            @click="toggleShowShareCode"
                        >
                        </i>
                        <span class="tw">分享码</span>
                        <span>（使用分享码可享受九折优惠）</span>
                    </div>
                    <div class="youhui-code" v-if="showShareCode">
                        <el-input
                            placeholder="请输入分享码"
                            size="mini"
                            v-model="payShareCode"
                            :disabled="useShared"
                        >
                            <template slot="append"  v-if="!useShared" ><div v-on:click="checkShareCode">验证</div></template>
                        </el-input>
                        &lt;!&ndash; <el-tooltip class="item" effect="dark" content="输入分享码享受九折优惠" placement="top">
                            <i class="el-icon-info youhui-tip"></i>
                        </el-tooltip> &ndash;&gt;
                    </div>-->

                    <div class="djq" v-if="!havedjq">代金券：暂无可用代金券</div>
<!--                    <div class="djq">-->
<!--                        代金券：-->
<!--                        <el-select v-model="djqVal" placeholder="请选择代金券">-->
<!--                            <el-option-->
<!--                                v-for="item in djqOptions"-->
<!--                                :key="item.value"-->
<!--                                :label="item.label"-->
<!--                                :value="item.value"-->
<!--                            />-->
<!--                        </el-select>-->
<!--                    </div>-->
                    <div class="djq" v-if="havedjq">
                        代金券：
                        -￥{{ djqPrice }}
                        <el-select @change="changeDjq" v-model="djqVal" placeholder="请选择代金券">
                            <el-option
                                v-for="item in djqOptions"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            />
                        </el-select>
                    </div>

                    <div class="total">合计：<span>￥{{order.paymentAmount}}</span></div>
                     <div class="xieyi">
                        <el-checkbox v-model="agreeCheck">我已阅读并同意</el-checkbox>
                        <span class="xieyi-cont" @click="showXieyiEvent">《动画作品服务协议》</span>
                        <span style="font-size: 14px;">(温馨提示：该商品为数字虚拟产品，一旦付款，概不退费。)</span>
                    </div>
                    <div class="back-submit-btns">
                        <el-button @click="back" type="info">返回</el-button>
                        <el-button @click="toMobilePay" type="danger" v-if="isMobile" :disabled="!agreeCheck">确认付款</el-button>
                        <el-button @click="toPay" type="danger" v-else-if="wechatpayType == 'notwxpay'" :disabled="!agreeCheck">确认付款</el-button>
                        <el-button @click="toWxPay" type="danger" v-else :disabled="!agreeCheck">微信付款</el-button>
                    </div>
                </div>

            </div>
        </div>
        <el-dialog
                title="付款"
                :visible.sync="dialogVisible"
                :close-on-click-modal="false"
                :before-close="handleClose"
                width="300px"
        >
            <div class="qr-code" id="qrcodeImgEl" >
            </div>
            <span slot="footer" class="dialog-footer">
<!--        <el-button type="primary">已完成</el-button>-->
      </span>
        </el-dialog>
        <el-dialog
            :visible.sync="showXieyi"
            top="60px"
            width="80%"
            center
            :modal-append-to-body="false"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
        >
            <v-xieyi></v-xieyi>
            <span slot="footer" class="dialog-footer">
                <el-button type="info" @click="showXieyi = false">关 闭</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script type="text/ecmascript-6">
import shareRevenueApi from "@/api/shareRevenue";
import axios from 'axios';
import vue from 'vue';
import filmApi from "@/api/film";
import wx from 'weixin-js-sdk'
import Xieyi from './xieyi'
import userInfoApi from '@/api/userInfo'

    vue.prototype.$axios = axios;
    export default {
        components: {
            'v-xieyi': Xieyi
        },
        data() {
            return {
              loading:false,
                orderType:6, //剧集订单
                payTypeNum: 1,
                dialogVisible: false,
                tableData: [],
                order:{},
                WeiXin: '',
                ZhiFuBao: '',
                orderId:'',
                id: 0,
                timer: '',
                param: {
                    id: 0,
                    publishStatus:1,
                    publishDate:'',
                },
                courseId:0,
                sectionId:0,
                sectionIds:[],
                vcId:0,
                payShareCode:'',
                payShareCodeUserId:0,
                orderNumber:'',
                wechatpayType:'notwxpay',
                number:0.001,
                code:'',
                openid:'',
                wxObj:{},
                appid:'wxca4f9e282c9ff214',
                secret:'554a25400e6e7a01666d9381f22d8c73',
                shareRevenue:{
                    userId:0,
                    invitationCode:'',
                    orderId:0,
                    incomeAmount:0,
                    agentRankId:0,//代理等级
                    agentRankName:'',//代理等级名称
                    orderAmount:0,//订单金额
                },
                useShared:false, //验证码通过验证
                isMobile:false,
                showShareCode: false,
                agreeCheck: false,
                showXieyi: false,
                originalPrice:0,
                havedjq:false,
                djqList:[],
                djqOptions: [
                    {
                        value: '0',
                        label: '不使用代金券'
                    },
                ],
                djqVal: '',
                djqPrice:0,
                finalPrice:0,
            }
        },
        created(){//返回值
            let sectionId = this.getCookie('paySectionId')
            let ids =this.getCookie('payIds')
            let courseId=this.getCookie('payCId')

            let vcId=this.getCookie('payVcId')


            let payShareCode = this.getCookie('payShareCode')
            let payShareCodeUserId =  this.getCookie('payShareCodeUserId')

            if(ids.indexOf(",") > 0){
                let ar = ids.split(",")
                ar.forEach(re =>{
                    this.sectionIds.push(+re)
                })
            }else {
                this.sectionIds.push(ids)
            }

            let ua = navigator.userAgent;
            let ipad = ua.match(/(iPad).*OS\s([\d_]+)/),
                isIphone =!ipad && ua.match(/(iPhone\sOS)\s([\d_]+)/),
                isAndroid = ua.match(/(Android)\s+([\d.]+)/),
                isMobile = isIphone || isAndroid;
            //判断
            if(isMobile){
                if(this.is_weixn()=='notwxpay'){
                    this.isMobile = true
                }
            }else{
                this.isMobile = false
            }

            this.courseId = courseId
            this.sectionId = sectionId
            this.vcId = vcId
            this.payShareCode = payShareCode
            this.payShareCodeUserId = payShareCodeUserId
            if(this.payShareCode){
                this.useShared = true
            }

            if(this.is_weixn()=='wxpay'){
                let code=this.getUrlKey("code")
                this.code = code
                if(code){
                    let appid = this.appid
                    let secret = this.secret
                    let a_code = 'authorization_code'
                    let urlBak = 'https://api.weixin.qq.com/sns/oauth2/access_token?appid='+appid+'&secret='+secret+'&code='+code+'&grant_type='+a_code
                    const formData = new FormData() // 创建form对象
                    formData.append('urlString', urlBak)// 通过append向form对象添加数据
                    filmApi.wxTokenApi(formData).then(re => {

                        let jsonBackImg =  JSON.parse(re.response)
                        if(jsonBackImg.openid){
                            this.openid = jsonBackImg.openid
                            this.getQRCode(this.wechatpayType,1)
                        }else {
                            console.log("err")
                        }
                    })
                }else{
                    this.getCodeApi("STATE");
                }
            }
        },
        mounted() {
            //this.checkIsMobile()
            //this.is_weixn()

            let orderId = this.$route.query.orderId
            let paymentAmount = this.$route.query.paymentAmount

            console.log("this.$route.query====",this.$route.query)
            console.log("orderId====",orderId)
            if(orderId){

                this.shareRevenue.userId = this.payShareCodeUserId
                this.shareRevenue.incomeAmount = paymentAmount
                this.shareRevenue.invitationCode = this.payShareCode
                this.shareRevenue.orderId = orderId


                this.timer = setInterval(this.ifPayed, 2000);
            }else{

            }

            this.initData()
        },
        beforeDestroy() {
            clearInterval(this.timer);
        },
        methods: {
            changeDjq(index){
              console.log(index)
              this.selectDJQPrice();
            },
            selectDJQPrice(){
              let that = this;
              if(that.djqVal+"" =='0'){
                that.djqPrice = 0;

              }else{
                that.djqList.forEach(function (e){
                  if(e.id+"" == that.djqVal+""){
                    that.djqPrice = e.price;
                  }
                })
                console.log("that.order.paymentAmount",that.order.paymentAmount)
              }
              that.finalPrice = (that.order.paymentAmount + that.djqPrice).toFixed(2);
              if (this.payTypeNum == 0) {
                console.log("重新生成支付宝支付码")
                this.getQRCode(this.id,2)
              }
              if (this.payTypeNum == 1) {
                console.log("重新生成微信支付码")
                this.getQRCode(this.id,1)
              }
            },
          selectDJQPrice1(){
            let that = this;
            if(that.djqVal+"" =='0'){
              that.djqPrice = 0;
            }else{
              that.djqList.forEach(function (e){
                if(e.id+"" == that.djqVal+""){
                  that.djqPrice = e.price;
                }
              })
              console.log("that.order.paymentAmount",that.order.paymentAmount)
            }
            that.finalPrice = (that.order.paymentAmount + that.djqPrice).toFixed(2);

          },
            initData(){
              let that = this;
                filmApi.select(this.courseId).then(reCourse =>{
                    if(this.vcId !=0){
                      console.log("this.vcId",this.vcId)
                        filmApi.getVideoCollection(this.vcId).then(re=>{
                          //查询是否有可用代金券
                          let url="/rrbi/coupon/getMyCoupons/0?collectionId="+this.vcId+"&ti="+new Date().getMilliseconds();
                          that.$axios.get(url).then(function(result){
                            if(result.data.response.list.length>0){
                              that.havedjq= true;
                              console.log("result.data.response.list",result.data.response.list)
                              that.djqList = result.data.response.list;
                              that.djqOptions =[];
                              result.data.response.list.forEach(function (re){
                                console.log("re===================",re)
                                let option = {
                                  value: '',
                                  label: ''
                                }
                                option.value = re.id;
                                option.label = re.couponName+"（￥"+re.price+"）"
                                that.djqOptions.push(option)
                              })
                              that.djqOptions.push({
                                value: '0',
                                label: '不使用代金券'
                              });
                              that.djqVal = that.djqOptions[0].value;
                              that.getQRCode(that.id,1)
                            }
                          })
                            if(re.code == 1){
                                this.originalPrice =re.response.currentPrice
                            }

                        })
                    }else {
                        let idsLen =this.sectionIds.length
                        if(idsLen == 20){
                            let selTag =  JSON.parse(reCourse.response.discountPrice)
                            selTag.forEach(priceItem => {
                                if(priceItem.type == 20){
                                    this.originalPrice = priceItem.price
                                }
                            })
                        }else if(idsLen == 10){
                            let selTag =  JSON.parse(reCourse.response.discountPrice)
                            selTag.forEach(priceItem => {
                                if(priceItem.type == 10){
                                    this.originalPrice = priceItem.price
                                }
                            })
                        }else {
                            this.originalPrice = reCourse.response.coursePrice
                        }
                    }


                })


                this.wechatpayType = this.is_weixn()
                //判断是否手机 环境
                if(this.wechatpayType == 'notwxpay'){
                    this.getQRCode(this.wechatpayType,1)
                }
                if(this.wechatpayType == 'wxpay' && this.openid){
                    this.getQRCode(this.wechatpayType,1)
                }
            },
            back(){
                // this.$router.push({
                //     path:'/filmdetail',
                //     query: {id:this.sectionId}
                // })
                window.location.href="/filmdetail?id="+this.sectionId
            },
            getCookie(key) {
                let cookies = document.cookie.split(';')
                for (let cookie of cookies) {
                    let c = cookie.trim()
                    if (c.indexOf(key + '=') !== -1) {
                        return c.slice(key.length + 1, c.length)
                    }
                }
                return ''
            },
            selectPayType(num) {
                this.payTypeNum = num
                if(this.havedjq){
                  this.selectDJQPrice();
                }else{
                  if (this.payTypeNum == 0&&this.ZhiFuBao == '') {
                    this.getQRCode(this.id,2)
                  }
                  if (this.payTypeNum == 1&&this.WeiXin == '') {
                    this.getQRCode(this.id,1)
                  }
                }


            },
            toMobilePay(){
                //查询订单是否支付完成
                this.timer = setInterval(this.ifPayed, 2000);

                if (this.payTypeNum == 0) {
                    //PC支付宝
                    let form = this.ZhiFuBao.credential
                    /*const div = document.createElement('div')
                    div.innerHTML = form//此处form就是后台返回接收到的数据
                    document.body.appendChild(div)
                    document.forms[0].submit()*/

                    // 添加之前先删除一下，如果单页面，页面不刷新，添加进去的内容会一直保留在页面中，二次调用form表单会出错
                    let divForm = document.getElementsByTagName('divform')
                    if (divForm.length) {
                        document.body.removeChild(divForm[0])
                    }
                    const div=document.createElement('divform');
                    div.innerHTML=form; // data就是接口返回的form 表单字符串
                    document.body.appendChild(div);
                    document.forms[0].setAttribute('target', '_blank') // 新开窗口跳转
                    document.forms[0].submit();



                } else {
                    //PC 微信
                    let urlNow=encodeURIComponent('http://www.renrendonghua.com/filmdetail?id='+this.sectionId);
                    let url =this.WeiXin.credential
                    //window.open(url+"&redirect_url="+urlNow)
                    window.open(url+"&redirect_url="+urlNow)

                }
            },
            toPay() {
                let _this = this
                _this.dialogVisible = true
                _this.$nextTick(() => {
                    const qrcodeImgEl = document.getElementById('qrcodeImgEl')
                    qrcodeImgEl.innerHTML = ''
                    let qrcode = new _this.QRCode(qrcodeImgEl, {
                        width: 150,
                        height: 150,
                        colorDark: '#000000',
                        colorLight: '#ffffff',
                        correctLevel: _this.QRCode.CorrectLevel.H
                    })
                    if (_this.payTypeNum == 0) {
                      qrcode.makeCode(_this.ZhiFuBao.credential);
                    } else {
                      qrcode.makeCode(_this.WeiXin.credential);
                    }
                    //查询订单是否支付完成
                    _this.timer = setInterval(_this.ifPayed, 2000);
                })

            },
            handleClose(done) {
                clearInterval(this.timer);
                done()
            },

            //调取微信支付
            toWxPay(){
                let this_ = this
                let wxobj = this.wxObj

                let appId = wxobj.appId;
                let timestamp = wxobj.timeStamp;
                let nonceStr = wxobj.nonceStr;
                let signature = wxobj.signature;
                let packages = wxobj.package;
                let paySign = wxobj.paySign;
                let signType = wxobj.signType;
                wx.config({
                    debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                    appId: appId, // 必填，公众号的唯一标识
                    timestamp: timestamp, // 必填，生成签名的时间戳
                    nonceStr: nonceStr, // 必填，生成签名的随机串
                    signature: signature, // 必填，签名，见附录1
                    jsApiList: ['chooseWXPay'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
                });
                wx.ready(function () {
                    wx.chooseWXPay({
                        timestamp: timestamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
                        nonceStr: nonceStr, // 支付签名随机串，不长于 32 位
                        package: packages, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=***）
                        signType: signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
                        paySign: paySign, // 支付签名
                        success: function (res) {
                            // 支付成功后的回调函数
                            //console.log('支付成功后的回调函数===========',res)
                            if(this_.payShareCode){
                                //有兑换码，返现
                                shareRevenueApi.add(this_.shareRevenue).then( shareRe =>{})
                            }
                            this_.$message.success("支付成功")
                            // this_.$router.push({
                            //     path:'/filmdetail?id='+this_.sectionId
                            // })
                            window.location.href="/filmdetail?id="+this_.sectionId
                        },
                        cencel: function (res) {
                            //console.log('用户取消支付===========',res)
                        },
                        fail: function (res) {
                            //失败回调函数
                            //console.log('失败回调函数===========',res)
                        }
                    });
                });
                wx.error(function (res) {
                    // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
                    /*alert("config信息验证失败");*/
                    //console.log("config信息验证失败")
                });
            },




            //判断是否支付 --剧集数组中的第一个判断
            ifPayed() {

                let _this = this;
                let sId =  this.sectionIds[0]
                /*console.log('_this.payShareCode===',this.payShareCode)
                console.log('_this.shareRevenue===',this.shareRevenue)
                console.log('sId===',sId)*/
                if (_this.global.isLogin) {
                    let url = '/rrbi/pay/ifPayed?productId=' + sId + '&orderType=' + _this.orderType + '&time=' + new Date().getMilliseconds();
                    if(this.vcId != 0){
                        url = '/rrbi/pay/ifPayedForIds?productIds=' + this.sectionIds + '&orderType=' + _this.orderType + '&time=' + new Date().getMilliseconds();
                    }
                    _this.$axios.get(url).then(function (result) {
                        console.log('result===',result)
                        if (result.data == 1) {
                            clearInterval(_this.timer);
                            if(_this.payShareCode){
                                //有兑换码，返现
                                _this.shareRevenue.orderAmount = _this.shareRevenue.incomeAmount

                                console.log("_this.shareRevenue=====",_this.shareRevenue)
                                shareRevenueApi.add(_this.shareRevenue).then( shareRe =>{})
                            }
                            _this.$message.success("支付成功")
                            // _this.$router.push({
                            //     path:'/filmdetail?id='+_this.sectionId
                            //     //path: '/filmlist?num=1'
                            // })
                            window.location.href="/filmdetail?id="+_this.sectionId



                        }
                    })
                }
            },
            getOrderList() {
                let _this = this
                //根据订单号查询 订单信息 -- 总价
                let payNo =''
                console.log("_this.WeiXin.code",_this.WeiXin.code)

                if(_this.WeiXin.code != 'FAIL' && _this.payTypeNum ==1){
                    payNo = _this.WeiXin.tradePayNo
                }else {
                    payNo = _this.ZhiFuBao.tradePayNo
                }
                filmApi.selectByOrderNo(payNo).then(re =>{
                    let order = re.response
                    this.order = order
                    if(this.havedjq){
                      this.selectDJQPrice1();
                    }else{
                      this.finalPrice = order.paymentAmount;
                    }
                    if(this.payShareCode){
                        //返现信息赋值
                        this.shareRevenue.userId = this.payShareCodeUserId
                        this.shareRevenue.incomeAmount = this.order.paymentAmount
                        this.shareRevenue.invitationCode = this.payShareCode
                        this.shareRevenue.orderId = this.order.id
                    }


                    filmApi.getOrderList(order.id).then(re =>{
                        if (re.code == 1) {
                            _this.tableData = re.response
                        } else if (data.code == -1) {
                            _this.$message.error("参数错误")
                        } else if (data.code == -2) {
                            _this.$message.error("无权限访问")
                        } else if (data.code == -3) {
                            _this.$message.error("问题已删除")
                        }
                    })
                })
            },

            //生成订单 --
            getQRCode(wechatpayType,paymentChannel) {
                console.log("2333333333333333333333333")
                var _this = this;
                _this.loading = true;
                let url = ''
                let userCouponId =  _this.djqVal
                if(userCouponId ==0 ){
                  userCouponId = '';
                }
                //判断是否 微信环境 支付
                if(wechatpayType == 'wxpay'){
                    url = '/rrbi/pay/getQRCodeByList?' +
                        'openId='+_this.openid+'&vcId='+this.vcId+'&payType=1' +'&orderId=' + _this.orderId +
                        '&orderType=' + _this.orderType + '&payShareCode='+_this.payShareCode+
                        '&productIds=' + _this.sectionIds+ '&userCouponId=' + userCouponId + '&time=' + new Date().getMilliseconds();
                }else{
                    //非微信环境
                    // 判断是否手机支付
                    if(_this.isMobile){
                        //let urlNow=encodeURIComponent('http://www.renrendonghua.com/filmlist');
                        let urlNow='http://www.renrendonghua.com/filmlist'
                        url = '/rrbi/pay/getQRCodeByList?' +'paymentChannel='+paymentChannel+'&orderId=' + _this.orderId +
                            '&payType=2&returnUrl='+urlNow+'&orderType=' + _this.orderType+'&vcId='+this.vcId + '&payShareCode='+_this.payShareCode+
                            '&productIds=' + _this.sectionIds+ '&userCouponId=' + userCouponId + '&time=' + new Date().getMilliseconds();
                    }else {
                        url = '/rrbi/pay/getQRCodeByList?' +'paymentChannel='+paymentChannel+'&orderId=' + _this.orderId +
                            '&payType=0&orderType=' + _this.orderType+'&vcId='+this.vcId+ '&payShareCode='+_this.payShareCode+
                            '&productIds=' + _this.sectionIds + '&userCouponId=' + userCouponId + '&time=' + new Date().getMilliseconds();
                    }

                }
                _this.$axios.get(url).then(function (result) {
                    console.log("result===",result)
                    if (result.data.code == 1 ) {

                        //微信环境
                        if(wechatpayType == 'wxpay'){
                            _this.orderNumber = result.data.WeiXin.tradePayNo
                            _this.WeiXin = result.data.WeiXin
                            //_this.ZhiFuBao = result.data.ZhiFuBao

                            _this.wxObj = result.data.WeiXin.credential

                            _this.getOrderList()
                        }else if(paymentChannel ==1 && result.data.WeiXin.code == "SUCCESS" ){
                            _this.orderNumber = result.data.WeiXin.tradePayNo
                            _this.WeiXin = result.data.WeiXin
                            if(result.data.ZhiFuBao){
                                _this.ZhiFuBao = result.data.ZhiFuBao
                            }
                            _this.getOrderList()
                        }else if(paymentChannel ==2 && result.data.ZhiFuBao.code == "SUCCESS"){
                            _this.orderNumber = result.data.ZhiFuBao.tradePayNo
                            _this.ZhiFuBao = result.data.ZhiFuBao

                            _this.getOrderList()
                        }else{
                            if(result.data.WeiXin && result.data.WeiXin.code == "FAIL"){
                                _this.$message.error(result.data.WeiXin.msg)
                            }else {
                                _this.$message.error(result.data.ZhiFuBao.msg)
                            }
                        }
                        _this.orderId = result.data.order.id
                      _this.loading = false;
                    } else {
                        _this.$message.error(result.data.message)
                    }
                })
            },


            checkIsMobile() {
                let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
                //this.isMobile=flag;

            },


            is_weixn(){
                var ua = window.navigator.userAgent.toLowerCase();
                if (ua.match(/MicroMessenger/i) == 'micromessenger'){
                    return 'wxpay';
                } else {
                    return 'notwxpay';
                }
            },




            getCodeApi(state){//获取code
                let urlNow=encodeURIComponent(window.location.href);
                let scope='snsapi_base';    //snsapi_userinfo   //静默授权 用户无感知 snsapi_base snsapi_base
                let appid= this.appid
                let url=`https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${urlNow}&response_type=code&scope=${scope}&state=${state}#wechat_redirect`;
                window.location.replace(url);
            },
            getUrlKey(name){//获取url 参数
                return decodeURIComponent((new RegExp('[?|&]'+name+'='+'([^&;]+?)(&|#|;|$)').exec(location.href)||[,""])[1].replace(/\+/g,'%20'))||null;
            },
            toggleShowShareCode () {
                this.showShareCode = !this.showShareCode
            },
            showXieyiEvent () {
                this.showXieyi = true
            },
            //1 判断输入分享码 2 跳过分享码
            checkShareCode(){
                if(!this.payShareCode){
                    this.$message.error("分享码错误")
                    this.payShareCode=''
                    return false
                }
                const formDataCode = new FormData() // 创建form对象
                formDataCode.append('invitationCode', this.payShareCode)// 通过append向form对象添加数据
                userInfoApi.selectByInvitationCode(formDataCode).then(re => {
                    if(re.code == 1){
                        this.payShareCode=re.response.invitationCode
                        this.payShareCodeUserId=re.response.userId

                        this.useShared = true

                        this.initData()
                    }else{
                        this.$message.error(re.message)
                        this.payShareCode=''
                    }
                })
            },

        }
    }
</script>

<style scoped lang="less">
   // @import "../../../assets/less/stylePublic.less";

    .page-pay {
        padding-top: @NAVHEIGHT;
        padding-bottom: 30px;

        .table {
            padding-bottom: 30px;
            margin: 30px auto 10px;
            background: #fff;

            .tit {
                padding: 30px 50px 10px;
                color: #000;
                font-size: 18px;
                border-bottom: 2px solid #f6f6f6;
            }

            .table-f {
                margin: 0 50px;

                /deep/ .el-table--striped .el-table__body tr.el-table__row--striped td {
                    background: #f7faff;
                }
            }

            .price-style {
                color: @HEADBG;
            }
        }

        .pay-wrap {
            background: #fff;

            .com-pad {
                padding: 25px 50px;
            }

            .top-wrap {
                .tit {
                    color: #000;
                    font-size: 18px;
                    line-height: 24px;
                }

                .pay-type {
                    margin-top: 20px;

                    li {
                        padding: 10px;
                        margin-right: 30px;
                        float: left;
                        width: 200px;
                        height: 70px;
                        cursor: pointer;

                        img {
                            width: 100%;
                            height: 100%;
                        }

                        &.active {
                            position: relative;

                            &:after {
                                position: absolute;
                                left: 0;
                                top: 0;
                                content: '';
                                display: block;
                                width: 100%;
                                height: 100%;
                                border: 2px solid @HEADBG;
                            }
                        }
                    }
                }
            }

            .bot-wrap {
                border-top: 1px solid #f6f6f6;

                .price {
                    color: #676767;
                    font-size: 14px;
                    .oldd-p{
                        margin-left: 20px;
                        .p-p{
                            text-decoration: line-through;
                        }
                    }
                    .you-hui{
                        margin-left: 10px;
                        padding: 3px 4px;
                        border: 1px solid #999;
                        border-radius: 2px;
                    }
                }
                .youhui-code{
                    padding-left: 20px;
                    color: #333;
                    font-size: 14px;
                    line-height: 28px;
                    .el-input{
                        width: 230px;
                        /deep/.el-input-group__append{
                            cursor: pointer;
                        }
                    }
                    .youhui-tip{
                        margin-left: 5px;
                    }
                    &.share-code{
                        margin-top: 5px;
                        padding-top: 4px;
                        padding-left: 0;
                        line-height: 20px;
                        .btn-share-code{
                            font-weight: bold;
                            font-size: 18px;
                            vertical-align: text-bottom;
                            cursor: pointer;
                        }
                        .tw{
                            margin: 0 10px 0 5px;
                        }
                    }
                }
                .xieyi{
                    margin-top: 5px;
                    .xieyi-cont{
                        color: #409EFF;
                        font-size: 14px;
                        cursor: pointer;
                        text-decoration: underline;
                    }
                }
                .back-submit-btns{
                    margin-top: 20px;
                }

                .djq {
                    margin: 5px 0;
                    line-height: 32px;
                    font-size: 14px;
                }

                .total {
                    margin-top: 5px;
                    // margin-bottom: 20px;
                    color: #2f3032;
                    font-size: 22px;

                    span {
                        color: @HEADBG;
                    }
                }
                .el-button{
                    width: 80px;
                }
            }
        }

        .qr-code {
            margin: 0 auto;
            width: 150px;
            height: 150px;
            background: pink;
        }
    }

    @media screen and (max-width: 900px) {
        .page-pay {
            .table {
                margin: 0;
                width: 100%;

                .tit {
                    padding: 10px;
                }

                .table-f {
                    margin: 0 10px;
                }
            }

            .pay-wrap {
                .com-pad {
                    padding: 10px;
                }

                .top-wrap {
                    .pay-type {
                        margin-top: 10px;

                        li {
                            margin-right: 10px;
                            width: 150px;
                            height: 55px;
                        }
                    }
                }
                .bot-wrap{
                    .youhui-code{
                        display: flex;
                        align-items: center;
                        .el-input{
                            flex: 1;
                        }
                        // .youhui-tip{
                        //     margin-left: 5px;
                        // }
                    }
                }
            }
        }
    }
</style>
